import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trophy } from 'react-bootstrap-icons';

const SubscriptionCard = ({ subscription }) => {
  const isProActive = subscription?.status === 'active';
  
  return (
    <Card className="shadow-sm mb-4">
      <Card.Header className="bg-light d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Your Plan</h5>
        {isProActive && (
          <Badge bg="success" className="py-2 px-3">PRO</Badge>
        )}
      </Card.Header>
      <Card.Body>
        {isProActive ? (
          <div className="text-center py-3">
            <Trophy className="text-warning mb-3" size={36} />
            <h4 className="mb-3">Pro Plan</h4>
            <p className="text-muted">
              Next billing date: {new Date(subscription.currentPeriodEnd).toLocaleDateString()}
            </p>
            <div className="d-grid gap-2">
              <Button 
                as={Link} 
                to="/dashboard/subscription" 
                variant="outline-primary"
                size="sm"
              >
                Manage Subscription
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center py-3">
            <h4 className="mb-3">Basic Plan</h4>
            <p className="text-muted mb-4">
              Upgrade to Pro for unlimited clicks and conversions.
            </p>
            <div className="d-grid">
              <Button 
                as={Link} 
                to="/dashboard/subscription" 
                variant="primary"
              >
                Upgrade Now
              </Button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SubscriptionCard;
